export default "__VITE_ASSET__C7eW1fZZ__"